import { DollarSign, Sun, Plus, LayoutGrid } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Property } from '@/types/revenue-manager';
import { useCurrency } from '@/contexts/CurrencyContext';
import { CURRENCIES } from '@/config/currency';

interface HeaderProps {
  properties: Property[];
  selectedPropertyId: string;
  onPropertyChange: (propertyId: string) => void;
  onAddProperty: () => void;
}

export function Header({
  properties,
  selectedPropertyId,
  onPropertyChange,
  onAddProperty,
}: HeaderProps) {
  const selectedProperty = properties.find((p) => p.id === selectedPropertyId);
  const { currency, setCurrency, currencyConfig } = useCurrency();

  const truncateText = (text: string, maxLength: number = 25) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <TooltipProvider>
      <header className="flex items-center justify-between pb-3">
        <div className="flex items-center gap-4">
          <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-primary text-primary-foreground">
            <DollarSign className="h-7 w-7" />
          </div>
          <div>
            <h1 className="text-2xl font-bold">Revenue Manager</h1>
            <p className="text-muted-foreground">Dynamic pricing & availability control</p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          {/* <Button variant="outline" size="icon" className="h-10 w-10">
            <LayoutGrid className="h-4 w-4" />
          </Button> */}

          {/* <Select value={currency} onValueChange={setCurrency}>
            <SelectTrigger className="w-[140px]">
              <SelectValue placeholder="Currency" />
            </SelectTrigger>
            <SelectContent>
              {CURRENCIES.map((curr) => (
                <SelectItem key={curr.code} value={curr.code}>
                  <div className="flex items-center gap-2">
                    <span className="font-medium">{curr.symbol}</span>
                    <span>{curr.code}</span>
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select> */}

          <Tooltip>
            <TooltipTrigger asChild>
              <div>
                <Select value={selectedPropertyId} onValueChange={onPropertyChange}>
                  <SelectTrigger className="w-[250px]">
                    <SelectValue placeholder="Select property">
                      {selectedProperty && truncateText(selectedProperty.name)}
                    </SelectValue>
                  </SelectTrigger>
                  <SelectContent>
                    {properties.map((property) => (
                      <SelectItem key={property.id} value={property.id} title={property.name}>
                        <div className="flex flex-col items-start">
                          <span className="font-medium">{truncateText(property.name)}</span>
                          {/* <span className="text-xs text-muted-foreground">{property.location}</span> */}
                        </div>
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </TooltipTrigger>
            {selectedProperty && selectedProperty.name.length > 25 && (
              <TooltipContent>
                <p>{selectedProperty.name}</p>
              </TooltipContent>
            )}
          </Tooltip>

          {/* <Button variant="outline" size="icon" className="h-10 w-10" onClick={onAddProperty}>
            <Plus className="h-4 w-4" />
          </Button>

          <Button variant="outline" size="icon" className="h-10 w-10">
            <Sun className="h-4 w-4" />
          </Button> */}
        </div>
      </header>
    </TooltipProvider>
  );
}
